import styled from 'styled-components';

export const Image = styled.img`
  width: 96px;
  height: 96px;
`;
